export const skillsData = [
  {
    label: "FRONT END",
    data: [
      {
        skillName: "HTML",
        percentage: "90",
      },
      {
        skillName: "CSS",
        percentage: "70",
      },
      {
        skillName: "JAVASCRIPT",
        percentage: "70",
      },
      {
        skillName: "REACT",
        percentage: "90",
      },
    ],
  },
  {
    label: "BACK END",
    data: [
      {
        skillName: "JAVA",
        percentage: "40",
      },
      {
        skillName: "PYTHON",
        percentage: "20",
      },
      {
        skillName: "KOTLIN",
        percentage: "20",
      },
      {
        skillName: "NODE.JS",
        percentage: "80",
      },
    ],
  },

  {
    label: "DATABASES",
    data: [
      {
        skillName: "SQL",
        percentage: "30",
      },
      {
        skillName: "MONGO DB",
        percentage: "100",
      },
      {
        skillName: "SANITY",
        percentage: "80",
      },
    ],
  },
];
